<template>
    <section class="depoist_fund border-0 max-1440 pb-5">{{indixing}}
        <alert-notification v-if="notification_msg != ''"/>
        <div class="section_title">
            <h5>Whitelisted IP Address</h5>
        </div>
        <div class="row justify-content-center">
            <div class="customPop-up" v-if="Object.keys(ipData).length > 0 && transaction_id == ''">
                <div class="popupBody">
                    <div class="imgSrc-pop">
                        <img src="../../../../static/website/images/ipAdd.svg" alt="Icon">
                    </div>
                    <p>Are you sure you want to delete this IP Address?</p>
                    <div class="popfooter">
                        <button class="cap_btn-b blue" @click="close()">Cancel</button>
                        <button class="cap_btn blue" :class="(pageLoader)?'disabled':''"  @click="transaction_id = 1">Confirm</button>
                    </div>
                </div>
            </div>
            <div class="col-12 text-center max-500" v-else-if="transaction_id != '' && parseInt(get_user.profile.gAuthenticatorEnabled) == 0 ">
                <p class="mb-0">  Two factor authentication is disabled on your account. And as a security measure, we cannot remove IP unless 2FA is enabled.</p>
                <div class="form-group text-center mt-3">
                    <input type="submit" class="cap_btn blue px-4 large_btn" name="" value="Enable 2fa" @click="$parent.otp_allow = true">
                </div>
            </div>
            <div class="col-12 text-center" v-else-if="transaction_id != '' && parseInt(get_user.profile.gAuthenticatorEnabled) == 1">
                <div class="form-group customMid-IP">
                    <div class="position-relative">
                        <input type="text" class="form-control" name="otp" v-model="otp" v-validate="'required|digits:6'" placeholder=" ">
                        <label class="labeltext">Enter Google Authenticator Otp</label>
                        <span v-show="submitted && errors.has('otp')" class="text-danger">{{ errors.first('otp') }}</span>
                    </div>
                </div>
                <div class="form-group text-center mt-3">
                    <!-- <input type="submit" class="cap_btn blue px-4 large_btn"  :class="(pageLoader)?'disabled':''" name="" value="Submit" @click="updateIp()"> -->
                    <button class="cap_btn blue px-4 large_btn"  :class="(pageLoader)?'disabled':''" @click="updateIp()">Submit</button>
                </div>
            </div>
            <div class="col-12">
                <loader v-if="pageLoader"></loader>
                <div class="border position-relative border-radius-15 mt-4">
                    <div class="marketData table-responsive">
                        <table class="table table-striped border-0">
                            <thead>
                                <tr>
                                    <th>IP Address</th>
                                    <th>Added On</th>
                                    <th>Recent Activity</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody v-if="ipAddressList.records && ipAddressList.totalRecords > 0">
                                <tr v-for="(val,index) in ipAddressList.records" v-if="index >= (page - 1)*pageLimit && index < page*pageLimit">
                                    <td>{{val.ip_address}}</td>
                                    <td>{{formatDate(val.created)}}</td>
                                    <td>{{formatDate(val.recent_activity)}}</td>
                                    <td>
                                        <a class="t_ic" href="#" @click.prevent="open(val)"><feather type="x-circle"></feather></a>
                                    </td>
                                </tr>
                            </tbody>
                            <table-loader :pageloader_value="pageLoader" :type="'table'" :colspan="'4'" :listLength="ipAddressList.totalRecords" v-else></table-loader>
                        </table>
                    </div>
                    <pagination :totalRecords="ipAddressList.totalRecords" :limit="pageLimit" :pageNo="page" v-if="ipAddressList.totalRecords > parseInt(pageLimit)"></pagination>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { userOperationMixins } from '@/plugins/userOperation'
export default {
    name: 'Ip-List',
	mixins: [userOperationMixins],
    data(){
        return {
            pageLoader: false,
            notification_msg:'',
            notification_type:'',
            ipData:{},
            page : '1',
            pageLimit : '10',
            transaction_id : '',
            otp : '',
        }
    },
    computed:{
        indixing(){
            if(this.ipAddressList.totalRecords){
                if(Math.ceil(this.ipAddressList.totalRecords/parseInt(this.pageLimit)) <= (this.page - 1)){
                    this.page = parseInt(this.page) - 1
                }
            }
        }
    },
    methods: {
        open(val){
            $(".mid_scroll_content").addClass("openModal");
            this.ipData = val
        },
        close(){
            $(".mid_scroll_content").removeClass("openModal");
            this.ipData = {}
        },
        updateIp(){
            if(this.pageLoader){return;}
            // this._runUpdateIpAddress({ 'globalParams' :{ 
            //     'status': '0',
            //     'id':this.ipData.id 
            // }, 'localParams':{"parameter" : this} })
            this.submitted = true;
            this.$validator.validate().then(valid => {
                if (valid) {
                    let input_json={
                        'globalParams' :{
                            'status': '0',
                            'id':this.ipData.id ,
                            'ip_address' : this.ipData.ip_address,
                            'otp' : this.otp,
                            'trans_id' : this.transaction_id
                        },
                        'localParams' :{ "parameter" : this, step: 2}
                    }
                    this._runUpdateIpAddress(input_json)
                }
            });
        },
        getIpList(){
            if(this.pageLoader){return;}
            this.ipData = {}
            this.transaction_id = ''
            this.otp = ''
            this.submitted = false
            this._runGetIpAddressList({ 'globalParams' :{}, 'localParams':{"parameter" : this} })
        }
    },
    created(){
		this.getIpList()
    }
}
</script>


// WEBPACK FOOTER //
// src/components/website/ip-whiteList/list.vue